import CryptoJS from 'crypto-js'
// 十六位十六进制数作为密钥
const KEY = CryptoJS.enc.Utf8.parse('gitaSecretkey321')
const IV = CryptoJS.enc.Utf8.parse('123gitaSecretkey')

/**

 * AES加密 ：字符串 key iv  返回base64

 */

export function encrypt(word, keyStr, ivStr) {
  let key = KEY

  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr)

    iv = CryptoJS.enc.Utf8.parse(ivStr)
  }

  let srcs = CryptoJS.enc.Utf8.parse(word)

  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,

    mode: CryptoJS.mode.CBC,

    padding: CryptoJS.pad.ZeroPadding,
  })

  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}
